import { MaybeRefOrGetter, useIntervalFn } from '@vueuse/core';
import { millisecondsToMinutes, millisecondsToSeconds } from 'date-fns';

import { TokenExpiration } from '../../schemas/token';

function calculateTimeout(blockedUntil: number | string) {
  const currentTimeDate = Date.now();
  const eventTimeDate = new Date(blockedUntil).getTime();

  return eventTimeDate - currentTimeDate;
}

function secondsToStr(ms: number) {
  const minutes = String(millisecondsToMinutes(ms) % 60).padStart(2, '0');
  const seconds = String(millisecondsToSeconds(ms) % 60).padStart(2, '0');

  return `${minutes}:${seconds}`;
}

export function useTokenResend(expirationInfo: MaybeRefOrGetter<TokenExpiration>) {
  const countDownMs = ref(calculateTimeout(0));
  const timerStr = computed(() => secondsToStr(countDownMs.value));
  const isInCooldown = computed(() => countDownMs.value > 0);
  const hasAttempts = computed(() => toValue(expirationInfo).remainingAttempts > 0);

  const { pause, resume } = useIntervalFn(() => {
    countDownMs.value -= 1000;

    if (countDownMs.value <= 0) pause();
  }, 1000);

  watch(() => toValue(expirationInfo), () => {
    if (!hasAttempts.value) return;

    countDownMs.value = calculateTimeout(toValue(expirationInfo).blockedUntil);
    resume();
  }, { immediate: true, deep: true });

  return {
    hasAttempts,
    timerStr,
    isInCooldown,
    countDownMs,
  };
}
